import React from 'react';

import { dateToPretty } from '@eika-kortbetjening/date-utils';
import { Modal } from '@eika/modal';

import { Calculator, SiteCoreDictionary } from '../types';

import './ConvertRateDetails.scss';

interface ConvertRateDetailsProps {
    calculator: Calculator;
    priceListPath: string;
    dictionary: SiteCoreDictionary;
}

const ConvertRateDetails = ({ calculator, priceListPath, dictionary }: ConvertRateDetailsProps) => {
    const {
        visaCalculatorDetailsInfoPrices,
        visaCalculatorDetailsInfoPriceList,
        visaCalculatorDetailsInfoVisa,
        visaCalculatorDetailsInfoDate,
    } = dictionary;

    const { exchangeRate } = calculator;

    const hideDate = typeof exchangeRate.from === 'undefined' || typeof exchangeRate.from.rateTimestamp === 'undefined';
    const time = exchangeRate?.from?.rateTimestamp;

    return (
        <article id="convert-rate-details">
            <p>
                <span>{`${visaCalculatorDetailsInfoPrices}, `}</span>
                <a className="price-list" href={priceListPath} target="_blank" rel="noreferrer">
                    {visaCalculatorDetailsInfoPriceList}
                </a>
                .
            </p>
            <p>{visaCalculatorDetailsInfoVisa}</p>
            {!hideDate && <p>{`${visaCalculatorDetailsInfoDate} ${dateToPretty(time, true)}.`}</p>}
        </article>
    );
};

interface ConvertRateDetailsModalProps {
    showDetailedInfoModal: boolean;
    setShowDetailedInfoModal: (value: boolean) => void;
    calculator: Calculator;
    priceListPath: string;
    dictionary: SiteCoreDictionary;
}

const ConvertRateDetailsModal = ({
    showDetailedInfoModal,
    setShowDetailedInfoModal,
    calculator,
    priceListPath,
    dictionary,
}: ConvertRateDetailsModalProps) => {
    const { visaCalculatorDetailsHeaderDesktop } = dictionary;
    return (
        <Modal
            title={visaCalculatorDetailsHeaderDesktop}
            open={showDetailedInfoModal}
            shouldCloseOnOverlayClick
            setOpen={() => {
                setShowDetailedInfoModal(false);
            }}
        >
            <ConvertRateDetails calculator={calculator} priceListPath={priceListPath} dictionary={dictionary} />
        </Modal>
    );
};

export default ConvertRateDetailsModal;
